import { Component, Inject, OnInit } from "@angular/core";
import { UntypedFormBuilder, UntypedFormGroup, Validators } from "@angular/forms";
import { MAT_DIALOG_DATA, MatDialogRef } from "@angular/material/dialog";
import { EN_BaseTable } from "src/shared/enam/en-base-table";
import { AlertDialogConfig } from "./alert-dialog-config.model";

@Component({
  selector: "vex-alert-delete",
  templateUrl: "./alert-delete.component.html",
  styleUrls: ["./alert-delete.component.scss"],
})
export class AlertDeleteComponent implements OnInit {

  title = 'پیام سیستمی';
  message = '';

  confirmText = 'بله';
  cancelText = 'خیر';

  showConfirm = true;
  showCancel = true;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: AlertDialogConfig,
    private dialogRef: MatDialogRef<AlertDeleteComponent>,
  ) {}

  ngOnInit(): void {
    if (!this.data) return;

    this.message = this.data.message;

    this.title = this.data.title ?? this.title;
    this.confirmText = this.data.confirmText ?? this.confirmText;
    this.cancelText = this.data.cancelText ?? this.cancelText;

    this.showConfirm = this.data.showConfirm ?? this.showConfirm;
    this.showCancel = this.data.showCancel ?? this.showCancel;
  }

  closeDialog(res: boolean) {
    this.dialogRef.close(res);
  }
}
